<template>
  <div class="decrypt-address">
    <span :class="{'decrypt-address__text': needDecrypt }" :title="address || ''">{{ address || "" }}</span>
    <el-button
      v-if="needDecrypt"
      type="text"
      icon="el-icon-unlock"
      class="decrypt-address__icon"
      @click="decryptBtn"
      title="解密地址"
    ></el-button>
  </div>
</template>

<script>
import { getUnprotectPhone } from "@/api/common-server.js";

export default {
  name: "DecryptAddress",
  props: {
    address: {
      type: [String, Number],
      default: "",
    },
    encryptAddress: {
      type: [String, Number],
      default: "",
    },
  },
  computed: {
    needDecrypt() {
      const encryptionInfo = this.encryptAddress || this.address;
      return encryptionInfo && /[a-zA-Z]+/.test(String(encryptionInfo));
    },
  },
  methods: {
    async decryptBtn() {
      const encryptionInfo = this.encryptAddress || this.address;
      if (!encryptionInfo) return;
      const { code, data, message } = await getUnprotectPhone({
        encryptionInfo,
      });
      if (code == 200) {
        this.$emit("update:address", data);
        return;
      }
      this.$message.error(message || "地址解密失败");
    },
  },
};
</script>

<style scoped>
.decrypt-address {
  display: inline-flex;
  align-items: center;
  max-width: 100px;
}

.decrypt-address__text {
  display: inline-block;
  max-width: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.decrypt-address__icon {
  margin-left: 4px;
  padding: 0;
}
</style>
